import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";

const path = (params: DeleteProductPicReqT) =>
  `product/${params.productId}/images/${params.picId}`;

const deleteProductPic = async (params: DeleteProductPicReqT) =>
  axios.delete(path(params));

export const useDeleteProductPic = () =>
  useMutation({
    mutationKey: [Keys.DELETE_PRODUCT_PIC_MUT],
    mutationFn: deleteProductPic,
  });
